import { render } from "./UpdateCustomerPage.vue?vue&type=template&id=1aedef7c&scoped=true&ts=true"
import script from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"
export * from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"

import "./UpdateCustomerPage.vue?vue&type=style&index=0&id=1aedef7c&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA/ZaloNHS/ZaloQUAN_NHS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aedef7c"]])

export default __exports__